import { App, initMotion, initSidebar, initTheme } from '@ims/app'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { useRegisterSW } from 'virtual:pwa-register/react'
import './index.css'
import { createBrowserPlatform } from './platform.ts'

initTheme()
initMotion()
initSidebar()

const platform = createBrowserPlatform({
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  apiUrl: import.meta.env.VITE_API_URL,
  menuUrl: import.meta.env.VITE_MENU_URL,
})

/** "New version available" prompt; the update waits so it never interrupts a bill. */
function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()
  if (!needRefresh) return null
  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-[70] flex items-center justify-center gap-3 bg-ink px-4 py-3 text-sm text-background"
    >
      A new version is ready.
      <button
        type="button"
        className="rounded-lg bg-background px-3 py-1 font-medium text-ink"
        onClick={() => void updateServiceWorker(true)}
      >
        Reload
      </button>
      <button
        type="button"
        className="text-background/70 hover:text-background"
        onClick={() => setNeedRefresh(false)}
      >
        Later
      </button>
    </div>
  )
}

if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) {
  document.getElementById('root')!.textContent =
    'Missing Supabase configuration (see apps/web/.env.example).'
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App platform={platform} />
      <UpdatePrompt />
    </StrictMode>,
  )
}
